<template>

  <div class="ability-column">
    <Title class="abilities-title" :title=abilityName size="medium" color="abilitiestitle" :translate=true direction="none" type="abilities"/>

    <div v-for="item,index in ability" class="ability-item" :class="'ability-item-'+item.type" :key="index">
      <AppImage class="one-one ability-image transparent" v-if="item.image" :src=item.image :key="item.description" :alt="item.name + ' ability icon'" />
      <div class="ability-meta">
        <p class="h4 roboto-condensed">
          {{item.name}}
          <AppImage class="one-one ability-icon transparent" v-if="item.icon" :src=item.icon :key="item.icon" :alt="item.name + ' ability icon'" />
        </p>
        <div class="roboto-condensed ability-description" v-html="item.description"></div>
      </div>
    </div>
  </div>

</template>


<script>
import AppImage from '@/components/ui/AppImage';
import Title from '@/components/ui/Title';

export default {
  name: 'AbilityColumn',
  props: ['abilityName', 'abilityData'],
  data() {
    return {
      keys: {
        basic_abilities: {
          name: 'ability_name',
          description: 'ability_description',
          header: require('@/assets/images/header-bg-7.png'),
          type: 'basic_abilities',
          icon: 'icon',
        },
        specials: {
          name: 'special_name',
          description: 'special_description',
          image: 'special_image',
          header: require('@/assets/images/header-bg-8.png'),
          type: 'specials',
          icon: 'icon',
        },
        supers: {
          name: 'super_name',
          description: 'super_description',
          image: 'super_image',
          header: require('@/assets/images/header-bg-9.png'),
          type: 'supers',
          icon: 'icon',
        }
      }
    }
  },
  components: {
    AppImage,
    Title
  },
  computed: {
    ability() {
      let data = [];
      this.abilityData.map((a) => {

        let item = {
          name: a[this.keys[this.abilityName].name],
          description: a[this.keys[this.abilityName].description],
          type: this.keys[this.abilityName].type
        };

        if(this.keys[this.abilityName].hasOwnProperty('image')) {
          item.image = a[this.keys[this.abilityName].image];
        } else {
          item.image = false;
        }

        if(this.keys[this.abilityName].hasOwnProperty('icon')) {
          item.icon = a[this.keys[this.abilityName].icon];
        } else {
          item.icon = false;
        }

        data.push(item)
      });

      return data;
    }
  },
  methods: {
    getHeader(ability) {
      return this.keys[ability]['header']
    }
  },

};
</script>

<style lang="scss">
.ability-item-specials {
  .image-wrapper {
    .image-content {
      background-image: url('~@/assets/images/special-icon-bg.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      }
  }
}

.abilities-title {
  margin-bottom: 35px;
}

.ability-item-supers {
  position: relative;

  .image-wrapper {
    .image-content {
      background-image: url('~@/assets/images/super-icon-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  &:after {
    width: 75px;
    content: 'OR';
    font-size: 14px;
    font-family: 'blackout sober';
    color: $greengrey;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    transform: translate3d(0, 100%, 0);

    @include bp($bp--m ) {
      margin: 0 20px;
      font-size: 16px;
      transform: translate3d(0, 70%, 0);
    }
  }

  &:last-child {
    &:after {
      content: none;
    }
  }
}

.ability-item {
  .ability-icon {
    width: 36px;
  }
}
.ability-description img {
  position: relative;
  top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/fighters/AbilityColumn.vue